<template>
    <div id="filtersubmit" class="filter-submit">
        <button class="filter-submit-button" @click="goTo">
          Reload <i class="material-icons">cached</i>
        </button>
    </div>
</template>

<script>
export default {
  name: 'filterSubmitButton',

  props: ['routeName', 'routeParams'],

  methods: {
    goTo () {
      this.$router.push({
        name: this.routeName,
        params: this.routeParams
      })
    }
  }
}
</script>

<style lang="scss">
@import "./src/sass/components/FilterSubmitButton.scss";  
</style>



// WEBPACK FOOTER //
// FilterSubmitButton.vue?3ccec857